

define(['angular', 'squid/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-bml-terms-and-conditions.route', ['squid', 'xo-bml-terms-and-conditions.directive']).factory('$BmlTermsAndConditionsRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('BmlTermsAndConditionsRoute', {

            name: 'bmltermsandconditions',
            trackingData: {
                fptiState: 'ppc_termsandconditions'
            },
            directive: 'xo-bml-terms-and-conditions-page',
            titleContent: 'applyForBml.bmlApplyHeadline',

            children: []

        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js
// module id = ./components/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/route.js
// module chunks = 1